import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import { Tooltip } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  table: {
    marginLeft: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  tableColumn: {
    flex: 1,
    textAlign: 'left',
  },
  status: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.palette.facet.accentGreen2,
    minWidth: '100px',
    textAlign: 'center',
  },
  statusText: {
    padding: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
  },
  statusCommentText: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
    maxWidth: '80px',
  },
  statusUser: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.darkGray,
    paddingLeft: theme.spacing(2),
  },
  date: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
    overflow: 'hidden',
    paddingLeft: theme.spacing(2),
  },
});

const View = ({ classes, rows }) => {
  return (
    <Box className={classes.root} debugColor="chartreuse">
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
      >
        History
      </Typography>
      <div className={classes.table}>
        {rows.map(row => (
          <div className={classes.row}>
            <div className={classes.tableColumn}>
              <div
                className={classes.status}
                style={{
                  backgroundColor: row.statusColors.backgroundColor,
                }}
              >
                <Typography
                  className={classes.statusText}
                  variant="h6"
                  color={row.statusColors.textColor}
                >
                  {row.stateChange}
                </Typography>
              </div>
            </div>
            <div className={classes.tableColumn} style={{ flex: 2 }}>
              <Typography
                className={classes.date}
                variant="h6"
              >
                {row.date}
              </Typography>
            </div>
            <div className={classes.tableColumn}>
              <Typography
                className={classes.statusUser}
                variant="h6"
              >
                {row.user}
              </Typography>
            </div>
            <div className={classes.tableColumn}>
              <Tooltip title={row.comment} arrow placement="top-end">
                <Typography
                  className={classes.statusCommentText}
                  variant="h6"
                  noWrap
                >
                  {row.comment}
                </Typography>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  rows: PropTypes.array,
};
View.defaultProps = {
  rows: [],
};

export default withStyles(styles)(View);
